import { Hospitalisation, Patient } from "@/src/data/allTypes";
import { AnswersTimelineCompartment } from "./answersTimeline/answersTimelineCompartment";
import { USER } from "@/src/data/globalVariables";
import { getItemId, isNurse } from "@/src/utils/utils";
import { openNewAnesthesiologySummaryForm } from "./historique/anesthesiologySummaryButton";
import { useState } from "react";
import { AnesthesiologySummariesList } from "./anesthesiologySummariesList";

export function AnesthesiologyTreatment({
  patient,
  item,
}: {
  patient: Patient;
  item: Hospitalisation;
}) {
  const [reload, setReload] = useState(0);
  function hasAccess() {
    const surgicalServices = [
      "chirurgie",
      "orl",
      "urologie",
      "ophtalmologie",
      // "cardiologie",
      "gynécologie",
    ];
    const serviceName = USER.get()?.service?.name?.toLowerCase() || "";
    for (let surgicalService of surgicalServices) {
      if (serviceName.includes(surgicalService)) return true;
    }
    return false;
  }

  if (!hasAccess()) return null;

  return (
    <AnswersTimelineCompartment
      key={`anesthesiologyTreatment-${getItemId(patient)}-${getItemId(
        item
      )}-${reload}`}
      color="purple"
      title={"Fiche anesthésie"}
      patient={patient}
      parent={item}
      additionalHtml={
        <AnesthesiologySummariesList
          key={`anesthesiologySummariesList-${getItemId(patient)}-${getItemId(
            item
          )}-${reload}`}
          patient={patient}
          parent={item}
        ></AnesthesiologySummariesList>
      }
      referenceIds={[
        "references:anesthesic_agents",
        "references:apports_iv",
        "references:sondage_vesical",
        "references:s_temp",
        "references:sondage_gastrique",
        "references:matelas_chauffant",
        "references:position",
        "references:YTM_",
        "references:YTE_",
        "references:YTI_",
        "references:YTU_",
        "references:diurese",
        "references:saignement",
        "references:fio2_n2o",
        "references:fluothane",
        "references:po2",
        "references:pco2",
        "references:saturation",
      ]}
      initialStatus="pending"
      buttonTitle={
        isNurse(USER.get()) ? undefined : "Ajouter résumé d'anesthésie"
      }
      onButtonClick={async () => {
        await openNewAnesthesiologySummaryForm({
          patient,
          parent: item,
          onSave: (item) => {
            setReload(reload + 1);
          },
        });
      }}
    ></AnswersTimelineCompartment>
  );
}
